import { render, staticRenderFns } from "./typhoon.vue?vue&type=template&id=d06b3a92"
import script from "./typhoon.vue?vue&type=script&lang=js"
export * from "./typhoon.vue?vue&type=script&lang=js"
import style0 from "./typhoon.vue?vue&type=style&index=0&id=d06b3a92&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports